import {Component} from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import {NavbarComponent} from "../../components/navbar/navbar.component";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-not-found-page',
  standalone: true,
  imports: [TranslateModule, NavbarComponent, RouterLink],
  templateUrl: './not-found.cmp.html',
  styleUrls: ['./not-found.cmp.scss']
})
export class NotFoundComponent {

}
